export const CONTACT_CONFIG_SUFFIX = 'contact_id';
export const CONTACT_API_SUFFIX = 'contact_ref_id';
export const CONFIGURED_FIELDS_PATHS = ['configuration.incident_details.configured_fields'];
export const FILTERS_DEFAULT = {
  searchText: '',
  selectedLob: '',
  subOrganizationIds: [],
};
